<template>
  <div class="block">
    <!-- <header-main>{{ $t("page.code_gen1.mainheader") }}</header-main> -->
    <img :src="MESSENGERS[messenger].logoInPhone" class="msgr_icon" />
    <TimerBlock
      class="timer"
      :seconds="seconds"
      :hasTimer="hasIntervalPooling"
      @timerFinish="timerFinish"
      @timerTicks="checkCustomStatus"
    ></TimerBlock>
    <p>{{ $t("page.code_gen1.text") }}</p>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onDeactivated } from "vue";
import TimerBlock from "@/components/Recurring/TimerBlockRecurring";
import { useRouter, useRoute } from "vue-router";
import { useStore, mapGetters } from "vuex";
import useCustomActivation from "./api/useCustomActivation";
import MESSENGERS from "@/data/messengers";

const router = useRouter();
const store = useStore();
const { getCustomStatus, customStatus } = useCustomActivation();

const seconds = ref(120);

const props = defineProps({
  number: {
    type: String,
  },
  numberId: {
    type: String,
    default: "",
  },
  messenger: {
    type: String,
    default: "viber",
  },
});

const emits = defineEmits(["nextStage"]);

const hasIntervalPooling = computed(() => !store.state.activation.isPusher);

const msgrColor = computed(() => MESSENGERS[props.messenger].color);

const checkCustomStatus = () => {
  getCustomStatus(props.number, props.messenger);
};

const timerFinish = () => {
  emits("nextStage", "timeOver");
};

onMounted(() => {
  if (!props.numberId && !props.number) {
    router.push({ name: "Oops" });
  }
});
</script>

<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  width: 100%;
  border-radius: 11px;
  background: var(--block-color);
}

img {
  margin-bottom: 35px;
}

.timer :deep(.p1),
.timer :deep(.p2),
.timer :deep(.p4),
.timer :deep(.p5) {
  color: v-bind(msgrColor);
}

p {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: var(--text-second-color);
}

@media screen and (max-width: 550px) {
  p {
    line-height: 150%;
    width: 85%;
    font-size: 12px;
  }
}

@media screen and (max-width: 450px) {
  .msgr_icon {
    scale: 0.7;
  }

  img {
    margin-bottom: 0;
  }
}
</style>
